import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'chatWithRovo'
	| 'viewAgentProfile'
	| 'editAgent'
	| 'copyLink'
	| 'switchAgent'
	| 'favoriteAgent'
	| 'searchPlaceholder'
	| 'browseAgents'
	| 'createAgent'
	| 'copyAgentLinkClickedTooltip'
	| 'createButtonDisabledTooltip';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		chatWithRovo: {
			id: 'ai-mate.chat-header-agent-menu.chat-with-rovo',
			defaultMessage: 'Chat with Rovo',
			description: 'Label for the chat to rovo menu item',
		},
		viewAgentProfile: {
			id: 'ai-mate.chat-header-agent-menu.view-agent-profile',
			defaultMessage: 'View agent profile',
			description: 'Label for the view agent profile menu item',
		},
		editAgent: {
			id: 'ai-mate.chat-header-agent-menu.edit-agent',
			defaultMessage: 'Edit agent',
			description: 'Label for the edit agent menu item',
		},
		copyLink: {
			id: 'ai-mate.chat-header-agent-menu.copy-link',
			defaultMessage: 'Copy link',
			description: 'Label for the copy link menu item',
		},
		switchAgent: {
			id: 'ai-mate.chat-header-agent-menu.switch-agent',
			defaultMessage: 'Switch to another agent',
			description: 'Label for the switch agent text',
		},
		favoriteAgent: {
			id: 'ai-mate.chat-header-agent-menu.favorite-agent',
			defaultMessage: 'Favorite',
			description: 'Label for the favorite agent menu item',
		},
		searchPlaceholder: {
			id: 'ai-mate.chat-header-agent-menu.search-placeholder',
			defaultMessage: 'Search agents',
			description: 'Placeholder for the search input',
		},
		browseAgents: {
			id: 'ai-mate.chat-header-agent-menu.browse-agents',
			defaultMessage: 'Browse agents',
			description: 'Label for the browse agents menu item',
		},
		createAgent: {
			id: 'ai-mate.chat-header-agent-menu.create-agent',
			defaultMessage: 'Create agent',
			description: 'Label for the create agent menu item',
		},
		copyAgentLinkClickedTooltip: {
			id: 'ai-mate.chat-header-agent-menu.copy-agent-link-clicked-tooltip',
			defaultMessage: 'Link copied!',
			description: 'Tooltip shown after copying the agent link',
		},
		createButtonDisabledTooltip: {
			id: 'ai-mate.chat-header-agent-menu.create-button-disabled-tooltip',
			defaultMessage: "You don't have permission to create agents in this site",
			description:
				'Tooltip to show when the create agent button is disabled due to user not having rovo agent create permissions on the site',
		},
	});

export default message;
